import { baseUrl } from '@fs/zion-config'

const relativesConfig = {
  eventIds: {
    integration: '8ec5a2c3-166c-4676-b6be-a65291059869',
    beta: '9d146578-5139-4961-b105-f6bd1dcbae43',
    prod: '8a37fa20-0398-41a6-b391-0b33657a9976',
  },
}
relativesConfig.previewUrl = `${baseUrl}/en/connect/${relativesConfig.eventIds.prod}`

export default relativesConfig
